export default __webpack_public_path__ + "static/media/servAccount1.7d512a55.png";